import { on } from '@ember/modifier';
import { PhCheckCircle, PhPencilSimple, PhXCircle } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

interface CompletedStepSummarySignature {
  Args: {
    stepNumber: number;
    label: string;
    summary: string;
    isComplete: boolean;
    onEdit: () => void;
  };
  Element: HTMLButtonElement;
}

const CompletedStepSummary: TOC<CompletedStepSummarySignature> = <template>
  <button
    type="button"
    class="border-b border-gray-200 pb-8 flex items-center justify-between w-full text-left cursor-pointer group"
    aria-label={{t "tas.guided.edit_step" step=@label}}
    {{on "click" @onEdit}}
    ...attributes
  >
    <div class="flex items-center gap-2">
      {{#if @isComplete}}
        <PhCheckCircle @size="24" @weight="fill" class="text-teal-500 shrink-0" />
      {{else}}
        <PhXCircle @size="24" @weight="fill" class="text-error-400 shrink-0" />
      {{/if}}
      <span
        class="font-semibold text-gray-500 group-hover:text-violet-600 transition-colors"
      >{{@label}}</span>
    </div>
    <div class="flex items-center gap-6">
      {{#if @summary}}
        <span
          class="font-medium text-gray-900 text-right truncate max-w-[200px]"
        >{{@summary}}</span>
      {{/if}}
      <span class="text-gray-400 group-hover:text-violet-600 transition-colors">
        <PhPencilSimple @size="18" />
      </span>
    </div>
  </button>
</template>;

export default CompletedStepSummary;
